import { ChainId } from '@usedapp/core'
import { SupportedChainId, SUPPORTED_CHAIN_NAME } from 'constants/chain'

export function isChainSupported(chainId: ChainId): chainId is SupportedChainId {
  return chainId in SUPPORTED_CHAIN_NAME
}
